export default __webpack_public_path__ + "static/logo-2369e61840b93de74780e35f9c2c0677.png";